import HeadphonesIcon from '@mui/icons-material/Headphones';
import SecurityIcon from '@mui/icons-material/Security';
import StarIcon from '@mui/icons-material/Star';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Menu, usePermissions } from 'react-admin';
import { When } from 'react-if';

import { SubMenu, SubMenuItem } from './SubMenu';

export default function SideMenu(): JSX.Element {
  const { permissions } = usePermissions();
  return (
    <Menu>
      <Menu.ResourceItem name='albums' />
      <SubMenu
        label='Engineers'
        icon={<HeadphonesIcon />}
        to='/engineers'
        matchPaths={['/engineers', '/engineer/order']}
      >
        <SubMenuItem
          to='/engineer/order?mode=selectedWork'
          primaryText='Selected Work'
          icon={<StarIcon fontSize='small' />}
        />
        <SubMenuItem
          to='/engineer/order?mode=careerHighlights'
          primaryText='Career Highlights'
          icon={<WorkspacePremiumIcon fontSize='small' />}
        />
      </SubMenu>
      <Menu.ResourceItem name='industry-contributors' />
      <When condition={permissions?.includes('root:admin')}>
        <Menu.Item
          to='/permissions'
          primaryText='Permissions'
          leftIcon={<SecurityIcon />}
        />
      </When>
    </Menu>
  );
}
